import { render, staticRenderFns } from "./CustomerInsuranceView.vue?vue&type=template&id=252018df&scoped=true&"
import script from "./CustomerInsuranceView.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252018df",
  null
  
)

export default component.exports